<div class="compare-cards">
  <ul [class.md-overlay]="mdOverlay" class="grid-row">
    <li
      [class.empty-card]="!comparison"
      [class.current-item]="i === 0"
      *ngFor="let comparison of comparisons; index as i"
      class="xs-12 md-4"
    >
      <article>
        <header>
          <span class="label typog-body-bold" *ngIf="i === 0">Current</span>
          <span class="label label-highlight typog-body-bold" *ngIf="i > 0"
            >New {{ i }}</span
          >
          <span
            class="typog-body-bold"
            *ngIf="comparison?.offer_type === offerType.UPGRADE && i !== 0"
            >Upgrade</span
          >
          <span
            class="typog-body-bold"
            *ngIf="comparison?.offer_type === offerType.REPLACEMENT && i !== 0"
            >Similar model</span
          >
          <span
            class="close-card typog-body-large"
            role="button"
            aria-label="Close compare card"
            *ngIf="i !== 0 && comparison"
            (click)="onRemove($event, comparison)"
          >
            <i class="fa-solid fa-xmark"></i>
          </span>
        </header>

        <div class="flex">
          <section class="image">
            <figure *ngIf="comparison">
              <img
                [src]="
                  (comparison.images && (comparison?.images)[0]?.url) ||
                  imageNotAvailable
                "
                [attr.alt]="
      comparison.images?.[0]?.text
        ? comparison.images[0].text
        : 'Product image of ' + comparison.make
    "
              />
            </figure>
          </section>
          <section class="content">
            <strong>
              {{ comparison?.make }}
            </strong>
            <p class="d-block">{{ comparison?.model }}</p>
            <p class="comparison__description">
              {{ comparison?.appliance_category }}
            </p>
            <ng-container
              *ngIf="comparison?.offer_type === offerType.REPLACEMENT"
            >
              <strong class="typog-body-large-bold compare-cards--free"
                >£0.00</strong
              >
            </ng-container>
            <ng-container *ngIf="comparison?.offer_type === offerType.UPGRADE">
              <strong class="typog-body-large-bold compare-cards--cost">{{
                comparison?.upgrade_fee | currency : 'GBP'
              }}</strong>
            </ng-container>
          </section>
        </div>
      </article>
    </li>
  </ul>
</div>
